import { makeCheckedRequest } from './requestExecutor/make-checked-request';
import type { IRequestOptions } from './types';

interface IPostRawRequestParams {
  path: string;
  body?: unknown;
  options?: IRequestOptions;
}

export async function postRawRequest({
  path,
  body,
  options,
}: IPostRawRequestParams): Promise<Response> {
  return makeCheckedRequest({ method: 'POST', path, body, options });
}
